export default __webpack_public_path__ + "static/media/tyler_profile.4c9ba836.jpg";